var addToBagButton = document.querySelectorAll('.featured-products__product-card--add-to-bag[data-add-to-bag]');

addToBagButton.forEach(function (button) {
    button?.addEventListener("click", function(e) {
        const key = `hue_event_${e.target.dataset.variantId}`
  
        const attributes = {
          [key]: JSON.stringify(window?.Hue?.checkoutProps)
        }
        
        let item = {
            id: e.target.dataset.variantId,
            quantity: 1,
            attributes,
        }
        VueMinicart.config.globalProperties.$store.dispatch('addItem', item);    
    });
});